import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import { BaseQuestionPreviewComponent } from '../../../bases';
import { useQuestionContext } from '../../../core';
import { AnswerItem } from './components';
import { Radio } from 'antd';
import styled from '@xstyled/styled-components';
import { getSize } from '@lib/common';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledAnswerContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n\n  margin-top: ", ";\n"])), getSize('padding12'));
var StyledAnswerGroup = styled(Radio.Group)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n\n  width: 100%;\n"])), getSize('padding12'));
var StyledQuestionTitle = styled.label(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 12px;\n  font-weight: 500;\n  color: #94a3b8;\n  line-height: 1rem;\n  text-transform: uppercase;\n"])));
export var SingleChoicePreviewComponent = function SingleChoicePreviewComponent(_ref) {
  var _singleChoiceQuestion, _singleChoiceQuestion2;

  var states = _ref.states,
      actions = _ref.actions;
  var singleChoiceLabel = states.singleChoiceLabel,
      readonly = states.readonly,
      isShowCorrectAnswer = states.isShowCorrectAnswer;

  var _useQuestionContext = useQuestionContext(),
      question = _useQuestionContext.question;

  var _useState = useState(null),
      selectedAnswerId = _useState[0],
      setSelectedAnswerId = _useState[1];

  var singleChoiceQuestion = question; // Fix: Handle case when correctAnswers is empty or undefined

  var correctAnswerId = ((_singleChoiceQuestion = singleChoiceQuestion.correctAnswers) === null || _singleChoiceQuestion === void 0 ? void 0 : (_singleChoiceQuestion2 = _singleChoiceQuestion[0]) === null || _singleChoiceQuestion2 === void 0 ? void 0 : _singleChoiceQuestion2.answerId) || null;
  return /*#__PURE__*/_jsxs(BaseQuestionPreviewComponent, {
    states: states,
    actions: actions,
    children: [/*#__PURE__*/_jsx(StyledQuestionTitle, {
      children: singleChoiceLabel.answers
    }), /*#__PURE__*/_jsx(StyledAnswerContainer, {
      children: /*#__PURE__*/_jsx(StyledAnswerGroup, {
        value: isShowCorrectAnswer ? correctAnswerId : selectedAnswerId,
        onChange: function onChange(e) {
          return setSelectedAnswerId(e.target.value);
        },
        children: (singleChoiceQuestion.answers || []).map(function (answer, index) {
          var _singleChoiceQuestion3, _singleChoiceQuestion4;

          return /*#__PURE__*/_jsx(AnswerItem, {
            answer: answer,
            index: index,
            isSelected: selectedAnswerId === answer.id.toString(),
            readonly: readonly,
            correctAnswerId: (_singleChoiceQuestion3 = singleChoiceQuestion.correctAnswers) === null || _singleChoiceQuestion3 === void 0 ? void 0 : (_singleChoiceQuestion4 = _singleChoiceQuestion3.find(function (correctAnswer) {
              return correctAnswer.answerId === answer.id.toString();
            })) === null || _singleChoiceQuestion4 === void 0 ? void 0 : _singleChoiceQuestion4.answerId,
            isShowCorrectAnswer: isShowCorrectAnswer
          }, answer.id.toString());
        })
      })
    })]
  });
};